import { createAction, handleActions } from 'redux-actions'
import { fromJS } from 'immutable'
import { createSelector } from 'reselect'

// Actions
export const fetchAccountProfile = createAction('ACCOUNT_PROFILE_FETCH')
export const fetchAccountProfileSuccess = createAction('ACCOUNT_PROFILE_FETCH_SUCCESS')
export const fetchAccountProfileFail = createAction('ACCOUNT_PROFILE_FETCH_FAIL')

export const updateAccountProfile = createAction('ACCOUNT_PROFILE_UPDATE')
export const updateAccountProfileSuccess = createAction('ACCOUNT_PROFILE_UPDATE_SUCCESS')
export const updateAccountProfileFail = createAction('ACCOUNT_PROFILE_UPDATE_FAIL')

export const fetchAccountProfileOptions = createAction('ACCOUNT_PROFILE_OPTIONS_FETCH')
export const fetchAccountProfileOptionsSuccess = createAction('ACCOUNT_PROFILE_OPTIONS_FETCH_SUCCESS')
export const fetchAccountProfileOptionsFail = createAction('ACCOUNT_PROFILE_OPTIONS_FETCH_FAIL')

export const actions = {
  fetchAccountProfile,
  fetchAccountProfileSuccess,
  fetchAccountProfileFail,
  updateAccountProfile,
  updateAccountProfileSuccess,
  updateAccountProfileFail,
  fetchAccountProfileOptions,
  fetchAccountProfileOptionsSuccess,
  fetchAccountProfileOptionsFail
}

const defaultState = fromJS({
  data: {},
  isFetching: true,
  options: {},
  error: {}
})

export default handleActions({
  [fetchAccountProfileSuccess]: (state, action) => {
    return state.mergeDeep({
      data: action.payload,
      isFetching: false
    })
  },

  [fetchAccountProfileFail]: (state, action) => {
    return state.mergeDeep({
      error: action.payload,
      isFetching: false
    })
  },

  [updateAccountProfileSuccess]: (state, action) => {
    return state.mergeDeep({
      data: action.payload
    })
  },

  [updateAccountProfileFail]: (state, action) => {
    return state.mergeDeep({
      error: action.payload
    })
  },

  [fetchAccountProfileOptionsSuccess]: (state, action) => {
    return state.mergeDeep({
      options: action.payload
    })
  },

  [fetchAccountProfileOptionsFail]: (state, action) => {
    return state.mergeDeep({
      error: action.payload
    })
  }
}, defaultState)

// selectors
const accountProfileSelector = state => state.account.profile.get('data')
const isFetchingSelector = state => state.account.profile.get('isFetching')
const accountProfileOptionsSelector = state => state.account.profile.get('options')

export const getAccountProfile = createSelector(
  accountProfileSelector,
  data => data.toJS()
)

export const isFetching = createSelector(
  isFetchingSelector,
  isFetching => isFetching
)

export const getAccountProfileOptions = createSelector(
  accountProfileOptionsSelector,
  options => options.toJS()
)



// WEBPACK FOOTER //
// ./src/features/Account/accountProfile/accountProfileReducer.js